import { useAssessmentStore as useGlobalStore } from '../stores/assessmentStore';

// Wrapper hook to provide assessment-specific store access
export function useAssessmentStore(assessmentType: string) {
  const store = useGlobalStore();
  
  return {
    answers: store.loadProgress(assessmentType)?.answers || {},
    email: store.loadProgress(assessmentType)?.email || '',
    name: store.loadProgress(assessmentType)?.name || '',
    subscribe: store.loadProgress(assessmentType)?.subscribe || false,
    
    setAnswers: (answers: Record<string, any>) => {
      const current = store.loadProgress(assessmentType) || {
        currentStepIndex: 0,
        answers: {},
        email: '',
        name: '',
        subscribe: false
      };
      store.saveProgress(assessmentType, { ...current, answers });
    },
    
    setEmail: (email: string) => {
      const current = store.loadProgress(assessmentType) || {
        currentStepIndex: 0,
        answers: {},
        email: '',
        name: '',
        subscribe: false
      };
      store.saveProgress(assessmentType, { ...current, email });
    },
    
    setName: (name: string) => {
      const current = store.loadProgress(assessmentType) || {
        currentStepIndex: 0,
        answers: {},
        email: '',
        name: '',
        subscribe: false
      };
      store.saveProgress(assessmentType, { ...current, name });
    },
    
    setSubscribe: (subscribe: boolean) => {
      const current = store.loadProgress(assessmentType) || {
        currentStepIndex: 0,
        answers: {},
        email: '',
        name: '',
        subscribe: false
      };
      store.saveProgress(assessmentType, { ...current, subscribe });
    },
    
    clearProgress: () => store.clearProgress(assessmentType)
  };
}